import * as t from 'io-ts';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/lib/function';
// represents a true from an boolean
export const True = new t.Type('True', (u) => typeof u === 'boolean' && u, (u, context) => pipe(t.boolean.validate(u, context), E.chain(b => {
    return b ? E.right(b) : t.failure(b, context);
})), (t) => t);
// represents a false from a boolean
export const False = new t.Type('False', (u) => typeof u === 'boolean' && !u, (u, context) => pipe(t.boolean.validate(u, context), E.chain(b => {
    return !b ? E.right(b) : t.failure(b, context);
})), (f) => f);
//# sourceMappingURL=boolean.js.map